@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  display: block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.success-animation {
  animation: fadeIn 0.3s ease-out forwards;
}
